import config from 'Config'; /* eslint-disable-line */
import store from '../../';

export default async (fileName) => {
  const authUser = store.getState().user;
  return fetch(`${config.apiUrl}/active/users/${encodeURIComponent(fileName)}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      authorization: authUser.access_token,
      'grifin-user-key': authUser.publicKey,
    },
  })
    .then(function (response) {
      if (response.status !== 200 || false) {
        throw new Error(response.statusText);
      }
      return response;
    })
    .then(async (response) => {
      const json = await response.json();

      return { success: true, url: json };
    })
    .catch((error) => ({ error }));
};
